import { useEffect, useRef, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { LanguageProvider, useI18n } from "@/i18n/LanguageContext";
import Nav from "@/components/holding/Nav";
import MenuOverlay from "@/components/holding/MenuOverlay";
import BrandRail from "@/components/holding/BrandRail";
import Hero from "@/components/holding/Hero";
import Overview from "@/components/holding/Overview";
import Philosophy from "@/components/holding/Philosophy";
import Marquee from "@/components/holding/Marquee";
import OrbTechIO from "@/components/holding/OrbTechIO";
import Contact from "@/components/holding/Contact";
import Footer from "@/components/holding/Footer";

function Site() {
  const [menuOpen, setMenuOpen] = useState(false);
  const lenisRef = useRef(null);
  const { dir } = useI18n();

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
  }, [menuOpen]);

  const handleNavigate = (id) => {
    setMenuOpen(false);
    setTimeout(() => {
      const el = document.getElementById(id);
      if (!el) return;
      if (lenisRef.current) {
        lenisRef.current.scrollTo(el, { offset: -10, duration: 1.4 });
      } else {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }, 350);
  };

  return (
    <div
      className="relative min-h-screen bg-[#050505] text-white"
      data-testid="app-root"
      dir={dir}
    >
      <div className="grain" aria-hidden="true" />
      <Nav onMenuToggle={() => setMenuOpen(true)} />
      <MenuOverlay
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        onNavigate={handleNavigate}
      />
      <BrandRail />
      <main>
        <Hero />
        <Overview />
        <Philosophy />
        <Marquee />
        <OrbTechIO />
        <Contact />
        <Footer />
      </main>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Site />
    </LanguageProvider>
  );
}

export default App;
